import styled from 'styled-components';

export const InfoCellTextWrapper = styled.div`
  padding-top: 13px;
  margin-right: 100px;
`;
